module.exports = __webpack_public_path__ + "static/media/dashboard-cream.b0a24d8e.svg";